import { render } from "./PropertyFollowUp.vue?vue&type=template&id=fbc3df10&scoped=true"
import script from "./PropertyFollowUp.vue?vue&type=script&lang=js"
export * from "./PropertyFollowUp.vue?vue&type=script&lang=js"

import "./PropertyFollowUp.vue?vue&type=style&index=0&id=fbc3df10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc3df10"]])

export default __exports__